import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ServiceRequestCard = ({ request }) => {
  const getStatusColor = (status) => {
    const colors = {
      'Pending': 'bg-warning/10 text-warning border-warning/20',
      'In Review': 'bg-primary/10 text-primary border-primary/20',
      'Approved': 'bg-success/10 text-success border-success/20',
      'Rejected': 'bg-error/10 text-error border-error/20'
    };
    return colors?.[status] || 'bg-muted text-muted-foreground border-border';
  };

  const getUrgencyIcon = (urgency) => {
    const icons = {
      'Urgent': 'AlertTriangle',
      'High': 'AlertCircle',
      'Normal': 'Info',
      'Low': 'CheckCircle'
    };
    return icons?.[urgency] || 'Info';
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-5 hover:shadow-md transition-all duration-300">
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className="flex items-start gap-3 min-w-0 flex-1">
          <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center flex-shrink-0">
            <Icon name={request?.serviceIcon} size={20} color="var(--color-accent)" />
          </div>
          <div className="min-w-0 flex-1">
            <h4 className="text-sm md:text-base font-semibold text-foreground line-clamp-1 mb-1">
              {request?.title}
            </h4>
            <p className="text-xs text-muted-foreground">{request?.serviceType}</p>
          </div>
        </div>
        <span className={`px-2 md:px-3 py-1 rounded-full text-xs font-medium border whitespace-nowrap flex-shrink-0 ${getStatusColor(request?.status)}`}>
          {request?.status}
        </span>
      </div>
      <p className="text-xs md:text-sm text-muted-foreground mb-3 md:mb-4 line-clamp-2">
        {request?.description}
      </p>
      <div className="grid grid-cols-2 gap-3 mb-4">
        <div className="flex items-center gap-2">
          <Icon name="Calendar" size={14} className="text-muted-foreground flex-shrink-0" />
          <div className="min-w-0">
            <p className="text-xs text-muted-foreground">Submitted</p>
            <p className="text-xs md:text-sm font-medium text-foreground whitespace-nowrap">{request?.submittedDate}</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Icon name={getUrgencyIcon(request?.urgency)} size={14} className="text-muted-foreground flex-shrink-0" />
          <div className="min-w-0">
            <p className="text-xs text-muted-foreground">Urgency</p>
            <p className="text-xs md:text-sm font-medium text-foreground">{request?.urgency}</p>
          </div>
        </div>
      </div>
      {request?.assignedTo && (
        <div className="flex items-center gap-2 mb-4 p-2 bg-muted/50 rounded-md">
          <Icon name="User" size={14} className="text-muted-foreground flex-shrink-0" />
          <span className="text-xs text-muted-foreground">Assigned to:</span>
          <span className="text-xs md:text-sm font-medium text-foreground">{request?.assignedTo}</span>
        </div>
      )}
      <Button variant="outline" size="sm" fullWidth iconName="FileText" iconPosition="left">
        View Request Details
      </Button>
    </div>
  );
};

export default ServiceRequestCard;